import createLucideIcon from '../createLucideIcon';

const Battery = createLucideIcon('BatteryIcon', [
  [
    'rect',
    {
      x: '2',
      y: '7',
      width: '16',
      height: '10',
      rx: '2',
      ry: '2',
      key: '5j9scf',
    },
  ],
  ['line', { x1: '22', x2: '22', y1: '11', y2: '13', key: '4dh1rd' }],
]);

export default Battery;
